export default "__VITE_ASSET__CeRXgz6U__"